import React, { useEffect, useState } from 'react'
import {Clock} from 'lucide-react'

function HeroUrgencyBadge() {
  const [secondsLeft, setSecondsLeft] = useState(14 * 60 + 59)

  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsLeft((prev) => (prev > 0 ? prev - 1 : 14 * 60 + 59))
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  const minutes = Math.floor(secondsLeft / 60)
  const seconds = secondsLeft % 60
  const timeLabel = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`

  return (
    <div className="w-full max-w-[420px] mx-auto bg-white border-2 border-[#15803D] rounded-[16px] shadow-md px-6 py-5 sm:py-6 flex flex-col items-center gap-2 sm:gap-3 text-center">
      <div className="flex items-center gap-2">
        <Clock className="w-4 h-4 sm:w-5 sm:h-5 text-[#15803D]" />
        <span className="text-[#15803D] text-xs sm:text-sm font-bold tracking-wide uppercase">
          Oferta Especial de Lançamento
        </span>
      </div>

      <span className="text-[#E53935] font-bold text-4xl sm:text-5xl leading-none tabular-nums">
        {timeLabel}
      </span>

      <p className="text-[#4A4A4A] text-xs sm:text-sm">
        🔥 Esta condição promocional pode ser encerrada a qualquer momento.
      </p>
    </div>
  )
}

export default HeroUrgencyBadge
